import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import LayersContext from '../context/LayersContext';
import { blueGrey } from '@mui/material/colors'
import { announce } from '../util/Announcer';

const ImageButton = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  height: 58,
  [theme.breakpoints.down('sm')]: {
    width: '100% !important', // Overrides inline-style
  },
  '&:hover, &.Mui-focusVisible': {
    zIndex: 1,
    '& .MuiImageBackdrop-root': {
      opacity: .2,
    },
    '& .MuiImageMarked-root': {
      opacity: 0,
    },
  },
  margin: '5px',
  borderRadius: '5px',
}));

const ImageSrc = styled('span')({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 2,
  height: "35px",
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain'
});

const Image = styled('span')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '10px'
}));

const ImageBackdrop = styled('span')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: theme.palette.common.black,
  opacity: 0.0,
  transition: theme.transitions.create('opacity'),
  padding: '10px',
  borderRadius: '5px',
}));

export default function LayerButton(props) {
  const layersContext = React.useContext(LayersContext);
  const module = props.module;
  const title = module.name;
  const [on, setButtonOn] = React.useState(undefined !== layersContext[title] ? layersContext[title].enabled : module.defaultOn);
  const url = module.mapLayerIcon;
  const iconSize = module.mapLayerIconSize || 28;
  const setLayersOn = props.setLayersOn;
  const modules = props.modules;

  let style = {
    maxWidth: "100px",
    width: "100px"
  };

  var hasIcon = (url.trim() !== "");

  if (on) {
    style.backgroundColor = "rgb(255,255,255,0.8)"
  }

  const onClick = (e) => {
    setButtonOn(!on);
  }

  const onMouseEnter = module.announceLayerButtonOnHover ? () => {
    announce(`${module.label || title} layer, ${on ? 'on' : 'off'}`);
  } : undefined;

  React.useEffect(() => {
    if(layersContext[title] && layersContext[title].enabled !== on) {
      setButtonOn(layersContext[title].enabled)
    }
  },[layersContext, title])

  /**
   * Congestion layers are exclusive, manage them
   * here
   */
  React.useEffect(() => {
    setLayersOn(layersContext => {
      let newLayersContext = { ...layersContext };
      if (module.congestionLayer && on) {
        modules.forEach(mmodule => {
          if (mmodule.congestionLayer && mmodule.name !== title) {
            if(!newLayersContext[title]) {
              newLayersContext[title] = {enabled:false}
            } else {
              newLayersContext[title].enabled = false;
            }
          }
        });
      }
      if(!newLayersContext[title]) {
        newLayersContext[title] = {enabled:on}
      } else {
        newLayersContext[title].enabled = on;
      }
      return newLayersContext;
    })
  }, [on])
  
  return (
    <ImageButton
      focusRipple
      key={title}
      style={style}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
    >
      <ImageSrc style={{ backgroundImage: `url(${url})`,
     position: 'absolute',
     top: '50%',
     left: 0,
     right: 0,
     bottom: '10%',
     maxHeight: `${iconSize}px`,
     backgroundSize: 'contain',
     backgroundPosition: 'center',
     borderRadius: 8, }} />
      <ImageBackdrop className="MuiImageBackdrop-root" />
      <Image />
      <Typography
        component="span"
        variant="body3"
        color="black"
        sx={{
          position: 'absolute',
          top: hasIcon ? 0 : '10%',
          pb: 0,
          color: on ? blueGrey[900] : "white",
		  padding: '4px 8px',
			borderRadius: '4px',
        }}
      >
        {title}
      </Typography>
    </ImageButton>
  );
}